var map = {
	"./beer-drinks/becks.png": "015f",
	"./cold-drinks/apleshorle.png": "2c69",
	"./cold-drinks/capri-sonne.png": "fb0d",
	"./cold-drinks/cola-light.png": "f344",
	"./cold-drinks/cola.png": "7ff0",
	"./cold-drinks/fanta.png": "32c3",
	"./cold-drinks/glass.png": "629f",
	"./cold-drinks/sprite.png": "d77e",
	"./cold-drinks/water.png": "b507",
	"./fingerfood/currywurst-pommes.png": "04f5",
	"./fingerfood/currywurst.png": "379f",
	"./fingerfood/frenchdog.png": "f81a",
	"./fingerfood/grill-bratwurst-pommes.png": "7754",
	"./fingerfood/grill-bratwurst.png": "d6ac",
	"./fingerfood/hotdog.png": "d01a",
	"./fingerfood/krokets.png": "0bb4",
	"./fingerfood/nuggets.png": "1f9b",
	"./fingerfood/potato.png": "2919",
	"./fingerfood/wings.png": "f1d3",
	"./hot-drinks/cappucino-восстановлено.psd": "b7a8",
	"./hot-drinks/cappucino.png": "013b",
	"./hot-drinks/chocolate.png": "3bf8",
	"./hot-drinks/coffee.png": "c550",
	"./hot-drinks/latte.png": "1397",
	"./icons/cart.svg": "daca",
	"./icons/cross__icon.svg": "831f",
	"./icons/menu__icon.svg": "6521",
	"./icons/minus.svg": "3e24",
	"./icons/more.svg": "0f4c",
	"./icons/phone.svg": "c3bb",
	"./icons/trash.svg": "af22",
	"./logo.png": "cf05",
	"./pizza/antalya.png": "e6ee",
	"./pizza/balognese.png": "5e20",
	"./pizza/chicken.png": "6aff",
	"./pizza/firstoff.png": "e286",
	"./pizza/fruti-di-mare.png": "aa5d",
	"./pizza/funghi.png": "f0ee",
	"./pizza/hawaii.png": "9cfd",
	"./pizza/hollandaise.png": "8472",
	"./pizza/istanbul.png": "c558",
	"./pizza/mafia.png": "0797",
	"./pizza/margherita.png": "e5ac",
	"./pizza/mista.png": "bc26",
	"./pizza/mozzarella.png": "ab4c",
	"./pizza/posciutto-funghi.png": "1584",
	"./pizza/prosciutto.png": "a769",
	"./pizza/salami-funghi.png": "aa01",
	"./pizza/salami.png": "e2c4",
	"./pizza/sucuk.png": "0a22",
	"./pizza/tonno-cipolle.png": "8e51",
	"./pizza/werder.png": "d596"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";